import React from "react";
import { Dialog } from "primereact/dialog";
import { FiAlertTriangle } from "react-icons/fi";

function DeleteConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  loading,
}) {
  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      closable={!loading}
      dismissableMask={!loading}
      draggable={false}
      resizable={false}
      showHeader={false}
      style={{ width: "450px", maxWidth: "95vw" }}
      contentClassName="p-6 rounded-[20px]"
    >
      <div className="flex flex-col items-center text-center pt-2">
        <div className="w-16 h-16 bg-rose-50 border border-rose-100 rounded-full flex items-center justify-center mb-5">
          <FiAlertTriangle className="text-rose-500 text-3xl" />
        </div>

        <h3 className="text-xl text-navy-blue font-bold mb-2">
          {title || "Confirm Deletion"}
        </h3>

        <p className="text-gray-500 text-sm leading-relaxed mb-6">
          {message ||
            "Are you sure you want to perform this action? This step cannot be undone."}
        </p>

        <div className="flex gap-3 w-full">
          <button
            onClick={onClose}
            disabled={loading}
            className="flex-1 h-[46px] rounded-xl font-bold border border-gray-200 text-slate-600 hover:bg-gray-50 transition-all disabled:opacity-50 text-sm"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 h-[46px] rounded-xl font-bold bg-rose-500 text-white hover:bg-rose-600 transition-all shadow-md shadow-rose-200 disabled:bg-gray-400 text-sm"
          >
            {loading ? "Deleting..." : "Yes, Delete"}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default DeleteConfirmationModal;
